import React from 'react'
import { Paper } from '@material-ui/core'
import { CustomTooltip } from 'components'
import { formatNumber, FormatNumberOptions } from 'utils/utilities'

export type YellowSummaryCardProps = {
  title: string
  subTitle?: string
  minWidth?: string
  value: number | null | undefined
  valueFormat?: FormatNumberOptions
  valueChange?: number | null
  valueChangeFormat?: FormatNumberOptions
  valueChangePosition?: 'right' | 'bottom'
  tooltipLabel?: string
  tooltipValue?: number | null
  tooltipValueFormat?: FormatNumberOptions
  tooltipValueChange?: number | null
  tooltipValueChangeFormat?: FormatNumberOptions
  borderColor?: string
  positiveChangeColor?: string
  negativeChangeColor?: string
}

export const YellowSummaryCard: React.FC<YellowSummaryCardProps> = (props: YellowSummaryCardProps) => {
  const {
    title,
    subTitle,
    minWidth = '16rem',
    value,
    valueFormat,
    valueChange,
    valueChangeFormat,
    valueChangePosition = 'right',
    tooltipLabel,
    tooltipValue,
    tooltipValueFormat,
    tooltipValueChange,
    tooltipValueChangeFormat,
    borderColor = '#f5edd0',
    positiveChangeColor = '#00893F',
    negativeChangeColor = '#D8393A',
  } = props

  const valueChangeColor = () => {
    if (!valueChange || valueChange === 0) {
      return ''
    } else if (valueChange > 0) {
      return positiveChangeColor
    } else if (valueChange < 0) {
      return negativeChangeColor
    }
  }

  const ySCStyle = {
    borderColor: borderColor,
  }
  const valueChangeStyle = {
    color: valueChangeColor(),
  }

  return (
    <div style={{ minWidth: minWidth }} data-testid={`yellow-summary-card`}>
      <Paper elevation={0} className={`border-2`} style={ySCStyle}>
        <CustomTooltip
          value={
            tooltipLabel ? (
              <div className="flex flex-col items-center gap-1">
                <div>{tooltipLabel}</div>

                {(typeof tooltipValue === 'number' && (
                  <span className="text-xl">{`${formatNumber(tooltipValue, tooltipValueFormat)}`}</span>
                )) ||
                  (typeof tooltipValue !== 'undefined' && <span className="text-xl">-</span>)}

                {(typeof tooltipValueChange === 'number' && (
                  <span>{`${formatNumber(tooltipValueChange, tooltipValueChangeFormat)}`}</span>
                )) ||
                  (typeof tooltipValueChange !== 'undefined' && <span>-</span>)}
              </div>
            ) : (
              ''
            )
          }
        >
          <div className={`flex flex-col py-1 text-center rounded-md bg-yellow-50`}>
            <span className={`text-base font-semibold`}>{title}</span>
            {subTitle && <span className={`text-base`}>{subTitle}</span>}

            <div
              className={`flex items-center justify-center ${
                valueChangePosition === 'right' ? 'flex-row' : 'flex-col'
              }`}
            >
              {(typeof value === 'number' && (
                <span className={`text-2xl font-semibold`}>{`${formatNumber(value, valueFormat)}`}</span>
              )) || <span className={`text-2xl font-semibold`}>-</span>}

              {(typeof valueChange === 'number' && (
                <span className={`ml-1 text-base`} style={valueChangeStyle}>
                  {`${valueChangePosition === 'right' ? '(' : ''}${formatNumber(valueChange, valueChangeFormat)}${
                    valueChangePosition === 'right' ? ')' : ''
                  }`}
                </span>
              )) ||
                (typeof valueChange !== 'undefined' && (
                  <span className={`ml-1 text-base`}>{`${valueChangePosition === 'right' ? '(' : ''}-${
                    valueChangePosition === 'right' ? ')' : ''
                  }`}</span>
                ))}
            </div>
          </div>
        </CustomTooltip>
      </Paper>
    </div>
  )
}
